module.exports = __webpack_public_path__ + "static/smartagent-logo-text-c7b96117fe5288bb619f710368395177.svg";